export default "__VITE_ASSET__D3g9nu4q__"